<div class="container" style="min-height: calc(100vh - 119px)">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
